var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlugZap = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m2 22 3-3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 13.5 10 11"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 16.5 13 14"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m18 3-4 4h6l-4 4"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlugZap);
export { ForwardRef as ReactComponent };